var v1="<div class=\"gnp-date-input\"><div class=\"row row-date\"><div class=\"col-4\"><input type=\"number\" name=\"year\" ng-model=\"year\" max=\"9999\" placeholder=\"{{ 'YEAR' | translate }}\" tabindex=\"{{tindex}}\"/></div><div class=\"col-4\"><input type=\"number\" name=\"month\" ng-model=\"month\" placeholder=\"{{ 'MONTH' | translate }}\" tabindex=\"{{tindex + 1}}\"/></div><div class=\"col-4\"><input type=\"number\" name=\"day\" ng-model=\"day\" placeholder=\"{{ 'DAY' | translate }}\" tabindex=\"{{tindex + 2}}\"/></div></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/form/date-input.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/form/date-input.jade
// module id = 125
// module chunks = 0